import { api } from './api';

/**
 * Fetch a CSV (or any binary file) from an authenticated API endpoint
 * and trigger a browser download. JWT lives in JS memory, so we can't
 * just <a href="/v1/...">; the browser would skip the Authorization
 * header and the API rejects the request.
 *
 * Usage: downloadFromApi('/reports/payments.csv', 'payments.csv')
 */
export async function downloadFromApi(path: string, suggestedFilename: string): Promise<void> {
  const res = await api.get<Blob>(path, { responseType: 'blob' });
  const blob = res.data;

  // Honor server-provided filename if present.
  const cd = res.headers?.['content-disposition'] as string | undefined;
  let filename = suggestedFilename;
  if (cd) {
    const m = cd.match(/filename\*?=(?:UTF-8'')?["']?([^"';\r\n]+)/i);
    if (m && m[1]) filename = decodeURIComponent(m[1]);
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Free the blob URL after the click had a chance to start.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
